let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("kFOec"), load("9VvWo"), load("6G4QQ")]).then(() => parcelRequire('dzOK8'));